import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = !!supabaseUrl && !!supabaseAnonKey;

function createStubSupabase(): SupabaseClient {
  const err = new Error("Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.");
  const stub: any = {
    auth: {
      getSession: async () => ({ data: { session: null }, error: err }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe() {} } } }),
      signInWithOtp: async () => ({ data: null, error: err }),
      getUser: async () => ({ data: { user: null }, error: err }),
      signOut: async () => ({ error: err }),
    },
    from: () => ({
      select: async () => ({ data: null, error: err }),
      insert: async () => ({ data: null, error: err }),
      update: async () => ({ data: null, error: err }),
      delete: async () => ({ data: null, error: err }),
      upsert: async () => ({ data: null, error: err }),
      eq: () => stub.from(),
      in: () => stub.from(),
      lt: () => stub.from(),
      order: () => stub.from(),
      range: async () => ({ data: [], error: err }),
      single: async () => ({ data: null, error: err }),
      or: () => stub.from(),
    }),
    functions: {
      invoke: async () => ({ data: null, error: err }),
    },
    storage: {
      from: () => ({
        createSignedUrl: async () => ({ data: { signedUrl: null }, error: err }),
        upload: async () => ({ data: null, error: err }),
      }),
    },
  };
  return stub as SupabaseClient;
}

export const supabase: SupabaseClient = isSupabaseConfigured
  ? createClient(supabaseUrl!, supabaseAnonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : createStubSupabase();

